import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-xhr-backend'

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: 'pl',
        fallbackLng: 'pl',

        keySeparator: false,

        resources: {
            pl: {
                translations: require('locales/pl/translations.json'),
            },
            en: {
                translations: require('locales/en/translations.json'),
            },
        },

        ns: 'translations',
        defaultNS: 'translations',

        debug: process.env.NODE_ENV !== 'production',

        interpolation: {
            escapeValue: false,
        },

        react: {
            useSuspense: true,
        },
    })

i18n.languages = ['pl', 'en']

export default i18n
